import { HardwareType, HardwareTypeLabel, HardwareTypeLabelLowercase } from './types/types'

export const getHardwareTypeName = (type: HardwareType, lowerCase?: boolean): HardwareTypeLabel | HardwareTypeLabelLowercase => {
  switch (type) {
    case 'ROBOT':
      return lowerCase ? 'tessa voice' as HardwareTypeLabelLowercase : 'Tessa Voice' as HardwareTypeLabel
    case 'VOICE_ASSISTANT':
      return lowerCase ? 'tessa screen' as HardwareTypeLabelLowercase : 'Tessa Screen' as HardwareTypeLabel
  }
}
